import {
	Header as AriaHeader,
	MenuSection as AriaMenuSection,
	MenuTrigger as AriaMenuTrigger,
} from "react-aria-components";

import {
	DropdownDotsButton,
	DropdownItem,
	DropdownMenu,
	DropdownPopover,
	DropdownSeparator,
} from "./dropdown";

export const Dropdown = {
	DotsButton: DropdownDotsButton,
	Item: DropdownItem,
	Menu: DropdownMenu,
	Popover: DropdownPopover,
	Root: AriaMenuTrigger,
	Section: AriaMenuSection,
	SectionHeader: AriaHeader,
	Separator: DropdownSeparator,
};
